import React from 'react';
import ChooseLoanPurpose from '../PropertyDetailComponent/ChooseLoanPurpose/ChooseLoanPurpose';
import SuccessPopUP from '../../UserKyc/UserPopUP/PropertySuccessPopUp';
import PropertyKhata from '../PropertyDetailComponent/PropertyKhata/PropertyKhata';
import DevStatus from '../../PropertyDetail/PropertyDetailComponent/DevStatus/DevStatus';
import * as moment from 'moment';
import { object, string, number, array, boolean } from 'yup';
import AddHomeLoan from '../PropertyDetailComponent/HomeLoanDetails/AddHomeLoan';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import {
  addBtLoan,
  submitPropertyLocationAPI
} from '../../../common/constants/api';
import GoogleMap from '../../../components/GoogleAPI/GoogleAPI';
import FlatDetails from '../FlatDetails/CostAndFlatDetails';
import * as _ from 'lodash';
let custFormValue;
let selectedSubProperty = '',
  selectedProperty = '',
  constructionStatus = '',
  pinCode = '',
  allformValues = {},
  KhataId;

export const selectedPropertType = () => selectedProperty;
export const selectedSubPropertType = () => selectedSubProperty;
export const propertyConstructionStatus = () => constructionStatus;
export const proprertyPicode = () => pinCode;
export const FormValues = () => allformValues;
export const getKhataId = () => KhataId;

let mastervalidation = {
  developerName: { name: 'developerName', seachvalue: 'developerName' },
  projName: { name: 'projName', seachvalue: 'projName' },
  devPercentage: {
    name: 'devPercentage',
    seachvalue: 'devPercentage.value'
  },
  prosDate: { name: 'prosDate.date', seachvalue: 'prosDate.date.value' },
  prosMonth: {
    name: 'prosDate.month',
    seachvalue: 'prosDate.month.value'
  },
  prosYear: { name: 'prosDate.year', seachvalue: 'prosDate.year.value' }
};

let Steps = [
  {
    id: 'ChooseLoanPurpose',
    component: ChooseLoanPurpose,
    initialValues: {
      loanType: '',
      loneTypeID: '',
      typeOfProperty: '',
      typeOfPropertyId: '',
      iconTypeOfProperty: ''
    },
    onAction: async (sectionValues, formValues) => {
      selectedProperty = sectionValues.loanType;
      selectedSubProperty = sectionValues.typeOfProperty;
      custFormValue = sectionValues;
      allformValues['ChooseLoanPurpose'] = sectionValues;
    }
  },
  {
    id: 'LoanpropertLocation',
    component: GoogleMap,
    initialValues: {
      house_address: '',
      pin_code: '',
      property_not_identified: '',
      property_identified: '',
      lat: '',
      lng: '',
      city: '',
      state: '',
      notshowBorder: true,
      savedKhataId: ''
    },
    validationSchema: object().shape({
      house_address: string().when('property_identified', {
        is: true,
        then: string()
          .required('Required')
          .min(10, 'Too Short')
      }),
      pin_code: string().when('property_identified', {
        is: true,
        then: string()
          .required('Required')
          .matches(/\d{6}/, 'Pincode should be 6 digit number')
      })
    }),
    onAction: (sectionValues, formValues) => {
      KhataId = sectionValues.savedKhataId;
      allformValues['LoanpropertLocation'] = sectionValues;
      if (sectionValues.property_not_identified) {
        pinCode = false;
      } else {
        pinCode = sectionValues.pin_code;
      }
      if (sectionValues.property_identified) {
        let address,
          line1 = '',
          line2 = '';
        try {
          address = sectionValues.house_address
            .replace('India,', '')
            .split(',');
        } catch {
          address = '';
        }
        for (let i = 0; i < address.length; i++) {
          if (!address[i].trim()) continue;
          if (
            i < parseInt(parseInt(address.length) / 2) ||
            address.length < 3
          ) {
            line1 += address[i].trim() + ', ';
          } else {
            line2 += address[i].trim() + ', ';
          }
        }
        let submitData = {
          coordinates: {
            latitude: sectionValues.lat,
            longitude: sectionValues.lng
          },
          address: {
            line1: line1 ? line1 : sectionValues.house_address,
            line2: line2,
            city: sectionValues.city,
            state: sectionValues.state,
            pinCode: sectionValues.pin_code
          }
        };

        submitPropertyLocationAPI(getApplicantionInfo().leadId, submitData)
          .then(response => {
            if (response.error) {
              throw new error(response?.data?.message);
            }
          })
          .catch(error => {
            if (error.response) {
              throw new error(error.response?.data?.message);
            }
          });
      }
    }
  },
  {
    id: 'PropertyKhata',
    component: PropertyKhata,
    initialValues: {
      propertyTitleId: '',
      pinCode: proprertyPicode,
      savedKhataId: getKhataId
    },
    validationSchema: object().shape({
      propertyTitleId: string().when('pinCode', {
        is: true,
        then: string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {
      allformValues['PropertyKhata'] = sectionValues;
    }
  },
  {
    id: 'devStatus',
    // eslint-disable-next-line react/display-name
    component: () => <DevStatus formValues={custFormValue} />,
    initialValues: {
      completed: true,
      underDev: false,
      itsNewPurchase: false,
      itsPlotConstruction: false,
      plotType: 'new',
      developerName: '',
      projName: '',
      reraNo: '',
      preValues: '',
      devPercentage: {
        value: '',
        label: 'select'
      },
      prosDate: {
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(moment().format('YYYY')),
          label: String(moment().format('YYYY'))
        }
      }
    },

    validate: values => {
      const errors = {};
      let validation = [];
      if (
        values?.preValues?.loanType == 'Balance Transfer' &&
        values?.preValues?.typeOfProperty == 'Plot'
      ) {
        validation = [];
      } else if (
        (values?.preValues?.loanType == 'New Purchase' &&
          values?.preValues?.typeOfProperty == 'Independent House') ||
        values?.preValues?.loanType == 'Plot+Construction' ||
        values?.preValues?.loanType == 'Resale'
      ) {
        if (values.underDev) {
          validation = [
            mastervalidation['devPercentage'],
            mastervalidation['prosDate'],
            mastervalidation['prosMonth'],
            mastervalidation['prosYear']
          ];
        } else {
          validation = [];
        }
      } else if (values?.preValues?.loanType == 'Self Construction') {
        validation = [];
      } else if (values?.preValues?.loanType == 'Renovation/Improvement') {
        validation = [
          mastervalidation['developerName'],
          mastervalidation['projName']
        ];
      } else if (values.underDev) {
        validation = [
          mastervalidation['devPercentage'],
          mastervalidation['prosDate'],
          mastervalidation['prosMonth'],
          mastervalidation['prosYear'],
          mastervalidation['developerName'],
          mastervalidation['projName']
        ];
      } else if (values.completed) {
        validation = [
          mastervalidation['developerName'],
          mastervalidation['projName']
        ];
      }
      validation.map(each => {
        if (_.get(values, each.seachvalue, true) == '') {
          errors[each.name] = 'required';
        }
      });
      if (
        values.underDev &&
        values?.prosDate?.date?.value &&
        values?.prosDate?.month?.value
      ) {
        let userDate = `${values?.prosDate?.month?.value +
          '/' +
          values?.prosDate?.date?.value +
          '/' +
          values?.prosDate?.year?.value}`;

        const timeObj = new Date(userDate);
        const today = new Date();

        if (timeObj && timeObj.getTime() <= today) {
          errors['prosDate.date'] =
            'Possesion Date must be ahead of current date';
        }
      }
      return errors;
    },

    onAction: async (sectionValues, formValues) => {
      allformValues['devStatus'] = sectionValues;
      constructionStatus = sectionValues.underDev;
    }
  },
  {
    id: 'propertyDetails',
    component: FlatDetails,
    initialValues: {
      selectedSubProperty: selectedSubPropertType,
      selectedProperty: selectedPropertType,
      constructionStatus: propertyConstructionStatus,
      formValues: FormValues
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'AddHomeLoan',
    component: AddHomeLoan,
    initialValues: {
      id: 0,
      lender: '',
      propertyValue: '',
      interestRate: '',
      currentEmi: '',
      sanctionAmount: '',
      balanceAmount: '',
      totalTenure: '',
      balanceTenure: '',
      topUpAmount: '',
      sanctionDocId: null,
      statementDocId: null,
      addNewLoan: true,
      selectedSubProperty: selectedSubPropertType,
      selectedProperty: selectedPropertType
    },
    validationSchema: object().shape({
      lender: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      propertyValue: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      interestRate: number().when('addNewLoan', {
        is: true,
        then: number()
          .typeError('Please Enter Valid Interest Rate')
          .required('Required')
          .positive("Interest Rate can't start with a minus")
          .max(50, 'Please Enter Valid Interest Rate')
      }),
      sanctionAmount: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      balanceAmount: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      totalTenure: number().when('addNewLoan', {
        is: true,
        then: number()
          .typeError('Please Enter Valid Total Tenure')
          .required('Required')
          .positive("Total Tenure can't start with a minus")
          .max(1000, 'Please Enter Valid Total Tenure')
      }),
      balanceTenure: number().when('addNewLoan', {
        is: true,
        then: number()
          .typeError('Please Enter Valid Balance Tenure')
          .required('Required')
          .positive("Balance Tenure can't start with a minus")
          .max(1000, 'Please Enter Valid Balance Tenure')
      })
    }),
    onAction: async (sectionValues, formValues) => {
      if (sectionValues.addNewLoan) {
        let body = {
          obligationId: sectionValues.id,
          propertyMarketValue: sectionValues.propertyValue,
          sanctionedAmount: sectionValues.sanctionAmount,
          outstandingAmount: sectionValues.balanceAmount,
          currentRateOfInterest: sectionValues.interestRate,
          totalTenure: sectionValues.totalTenure,
          balanceTenure: sectionValues.balanceTenure,
          topUpAmount: sectionValues.topUpAmount
        };
        let applicant = getApplicantionInfo();
        await addBtLoan(applicant.leadId, body)
          .then(async () => {})
          .catch(error => {
            if (error.response) {
              throw new error(error.response?.data?.message);
            }
          });
      }
    }
  },
  {
    id: 'SuccessPopUP',
    component: SuccessPopUP
  }
];
export default Steps;
